import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-measurement',
  templateUrl: './measurement.component.html',
  styleUrls: ['./measurement.component.css']
})
export class MeasurementComponent implements OnInit {
  @ViewChild('closeModal', { static: false }) closeModal: ElementRef;
  resultobj: any = {};
  info = [];
  measurement = {
    mm_id: '',
    mm_name:'',
    mm_mc_id:1,  
  }

  create_measurement = {
    create_mm_id: '',
    create_mm_names:[{create_mm_name:"",time:Date.now()}] ,
    create_mm_mc_id:1,  
  }
  isSubmitInProg = false;
  isSubmitInProg1 = false;
  curpage = 1;
  lastpage = 1;
  perpage = 20;
  totalItem = 0;
  curForm = 'Create';
  pageLoadingImg = false;
  langText = {
    create: '',
    update: ''
  };
  up: any;
  selecTed: any[];
  cur_lang: string;
  favProducts=[];
  search = [];
  prodsel: any;
  mm_id: any;
  valErrors = <any>{};
  
  constructor(private apiService: ApiService, private coreService: CoreService, private translate: TranslateService,private modalService: NgbModal) { }
  ngOnInit() {

    
      this.create_measurement.create_mm_names.push({create_mm_name:"",time:Date.now()}); 
    this.translate.get(['Common.create', 'Common.update']).subscribe((res: string) => {
      this.langText.create = res['Common.create'];
      this.langText.update = res['Common.update'];
      this.curForm = this.langText.create;
      this.up = this.coreService.getUserPrivilage();
    });
    this.getInfo(this.curpage);
    this.apiService.cur_lang.subscribe(value =>{
      this.cur_lang = value;
    })
    this.selectMeasurementCategory(''); 
  }
  getInfo(pageNo) {
    this.pageLoadingImg = true;
    this.apiService.getAllMeasurements(pageNo, this.perpage).subscribe((res) => {
      this.info = res.data;
      this.pageLoadingImg = false;
      this.curpage = res.current_page;
      this.lastpage = res.last_page;
      this.totalItem = res.total;
    });
  }
  createServiceType(){
    this.curForm = this.langText.create;
    this.clearForm();
  }
  clearForm() {
    this.measurement = {
      
      mm_id: '',
      mm_name:'',
      mm_mc_id:1,
    };

     this.create_measurement = {
      
      create_mm_id: '',
      create_mm_names:[{create_mm_name:"",time:Date.now()}],
     
      create_mm_mc_id:1,
    };
  }
  editMeasurement(mm_id){
    this.curForm = this.langText.update;
    this.clearForm();
    this.resultobj = [];
    this.apiService.getMeasurement({mm_id: mm_id}).subscribe((res) => {
      this.measurement = {
        mm_id: res.mm_id,
        mm_name:res.mm_name,
        mm_mc_id:res.mm_mc_id,
      };
    });
  }
  deleteMeasurement(mm_id,curpage){
    if(confirm("Do you wish to void this entry?")){
      this.apiService.deleteMeasurement({mm_id: mm_id}).subscribe((res) => {
        this.coreService.showMessage(res.message);
      });
      this.getInfo(curpage); 
    }
  }


validateAndSubmit() {
    if (confirm('Do you wish to continue?')) {
      this.isSubmitInProg = true;
      let callFunction = '';
      if (this.curForm === this.langText.create) {
        callFunction = 'createMeasurement';
      }
      if (this.curForm === this.langText.update) {
        callFunction = 'updateMeasurement';
      }
      this.apiService[callFunction](this.measurement).subscribe((res) => {
        this.isSubmitInProg = false;
        if (res.error != null) {
          this.resultobj = res.error;
        } else {
          this.closeModal.nativeElement.click();
          this.getInfo(this.curpage);
          this.coreService.showMessage(res.message);
          this.clearForm();
          this.resultobj = {};
        }
      });
    }
}

selectMeasurementCategory(name: string) {
  let searchval = new FormData();
  searchval.append("mc_name", name);

  this.apiService.getMeasurementCategory(searchval).subscribe((res) => {
    this.search = res['data'];
  });
}

validateMeasure(){
    this.valErrors = {};
       let retVal = true;
      
           this.create_measurement.create_mm_names.forEach((element1, l) => {
            if(element1.create_mm_name == ''){
              this.valErrors['create_mm_name_' +l] = {msg : 'Required'};
              //return false;
              retVal =  false;
            }
          })

          return retVal;
}


validateAndCreate() {

 if(this.validateMeasure()){

  if (confirm('Do you wish to continue?')) {
      this.isSubmitInProg = true;
      let callFunction = '';
      if (this.curForm === this.langText.create) {
        callFunction = 'createMeasurement';
      }
      // if (this.curForm === this.langText.update) {
      //   callFunction = 'updateMeasurement';
      // }
      this.apiService[callFunction](this.create_measurement).subscribe((res) => {
        this.isSubmitInProg = false;
        if (res.error != null) {
          this.resultobj = res.error;
        } else {
          this.closeModal.nativeElement.click();
          this.getInfo(this.curpage);
          this.coreService.showMessage(res.message);
          this.clearForm();
          this.resultobj = {};
        }
      });
    }

 }     

    
}

 addNewMeasurementRow(index){
 
   
      this.create_measurement.create_mm_names.push({create_mm_name:"",time:Date.now()}); 
   

   
  }

   removeMeasurement(l){
    this.create_measurement.create_mm_names.splice(l, 1);
  }

   addNewMeasurementRowone(i,l) {
   
  if (this.create_measurement.create_mm_names.length > (l+1)) {
  // var indexK=document.getElementById("measurement_input_" +i+(l+1)); 
    $('.s_input_' +(l+1)).focus();
    $('.s_input_' +(l+1)).select();
    
  }     
 
}





}

